import * as types from './types';

const votedForPoll = (pollID, answerID, currentUserID) => ({
  type: types.VOTED_FOR_POLL,
  payload: {
    pollID,
    answerID,
    currentUserID
  }
});

export { votedForPoll };
